import { JSONSchema7 } from 'json-schema';
import Divider from '@mui/material/Divider';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import ControlState from '../../Shared/controlState';

export default (control: ControlState) => {
  const labelSchema = (control.schema?.properties as JSONSchema7Properties)[
    'label'
  ] as JSONSchema7;
  return (
    <>
      <h3>{labelSchema.default}</h3>
      <Divider />
    </>
  );
};
